export default "query durationPreset {\n  durationPreset {\n    value\n    label\n  }\n}\n";